// extracted by mini-css-extract-plugin
module.exports = {"table-wrapper":"TableLayout_table-wrapper__Mu4PK"};